import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrls } from '../appConstant';

@Injectable({
  providedIn: 'root'
})
export class UserContactService {

  userToken = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : '';
  constructor(private httpClient: HttpClient) { }

  postQuestionaireData(inviteToken):any{
    let url = baseUrls['bill'] + 'userservice/user-contacts/post-invite-signup';
    return  this.httpClient.post(url, {token: inviteToken},  {headers: { token: localStorage.getItem('userToken') }});
  }

}
